/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc
 */

export const getApprovalConfigurationRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getApprovalConfiguration',
  auth: 'app',
  fingerprint: '35lRVF4BpRHQht1aTd8b9IT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApproversRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getApprovers',
  auth: 'app',
  fingerprint: 'Eh2sXrQKQPuv1wchydvePIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const putApprovalConfigurationRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'putApprovalConfiguration',
  auth: 'app',
  fingerprint: 'dIXjR88WPQ9ZRV-mQuEGc4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendRequestToEnableApprovalsRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'sendRequestToEnableApprovals',
  auth: 'app',
  fingerprint: 'Jl5Rz9UpL-e_GCjzXfbQCYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listApproverCandidatesRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'listApproverCandidates',
  auth: 'app',
  fingerprint: '8x4o4ygqZnUp1MG7i1N6koT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAvailableApproversRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getAvailableApprovers',
  auth: 'app',
  fingerprint: 'BiOOTe1f9WnzUWtu9RuTXYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const putAvailableApproversRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'putAvailableApprovers',
  auth: 'app',
  fingerprint: 'WGb6dlmzoadpR8Bo9-fas4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const putApprovalTemplateRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'putApprovalTemplate',
  auth: 'app',
  fingerprint: 'HfYpIEzXir5SsX9zPdu2roT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteApprovalTemplateRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'deleteApprovalTemplate',
  auth: 'app',
  fingerprint: '6UuSzsLuvMGW_l6eC_Xmc4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};